// 模块
export default {
	home: {
		name: "首页"
	},
	page_out_trade_no: "商户单号"
};
